<mat-error
  [id]="'error-' + formElementModel.id"
  class="invalid-feedback row section-row"
  *ngIf="control.invalid && (control.dirty || control.touched)"
>
  <div
    *ngIf="control.errors?.['maxlength'] as maxLengthError"
    class="col section-col"
  >
    {{ validationErrorLabel }} must be no more than
    {{ maxLengthError.requiredLength }} characters long.
  </div>
  <div *ngIf="control.errors?.['pattern']" class="col section-col">
    {{
      formElementModel.errorMessages?.pattern
        ? formElementModel.errorMessages?.pattern
        : 'Invalid characters in ' + validationErrorLabel + '.'
    }}
  </div>
  <div *ngIf="control?.errors?.['required']" class="col section-col">
    {{
      formElementModel.errorMessages?.required
        ? formElementModel.errorMessages?.required
        : validationErrorLabel + ' is required.'
    }}
  </div>
  <div *ngIf="control.errors?.['email']" class="col section-col">
    {{
      formElementModel.errorMessages?.email
        ? formElementModel.errorMessages?.email
        : 'Invalid ' + validationErrorLabel + '.'
    }}
  </div>
</mat-error>
